module.exports = __webpack_public_path__ + "img/icon-cert.04954160.png";